<template>
    <div :class="!isVisible ? 'opacity-100' : 'opacity-0'" class="fixed bottom-4 left-0 right-0 mx-auto w-fit z-50 transition duration-150 ease-in-out">
        <a :href="targetId" class="bg-blue text-white px-6 py-3 rounded-full shadow-lg flex items-center gap-3 hover:bg-blue-700 transition-colors ease-in-out">
            <span>{{ text }}</span>
            <i class="fi fi-rs-shopping-cart text-white flex" />
        </a>
    </div>
</template>

<script>
export default {
    name: 'FloatingCTAButton',
    props: {
        text: {
            type: String,
            default: 'Jetzt Paket buchen'
        },
        targetId: {
            type: String,
            default: '#pricing-card'
        },
        isVisible: {
            type: Boolean,
            required: true
        }
    }
};
</script>
